import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux';
import Navbar from '../components/navbar'
import Footer from '../components/footer'
import ScrollToTop from '../components/scroll-to-top'
import hero from '../assets/images/hero/quienessomos.jpg'
import { LuInfo } from 'react-icons/lu'
import { Turnstile } from '@marsidev/react-turnstile'
import { setRegistrationinfo, setRegistrationerror } from '../slices/registrationSlice';
import useAuthStatus from '../hooks/useAuthStatus';

export default function Perfil() {
    const { status } = useAuthStatus();
    const csrfToken = localStorage.getItem('token');
    const dispatch = useDispatch();
    const member = useSelector((state) => state.authentication?.member);
    const [localmember, setLocalmember] = useState([]);
    const [isChecked, setIsChecked] = useState(false);
    const [captchaPassed, setCaptchaPassed] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [errorDeliveringMessage, SetErrorDeliveringMessage] = useState('');
    const [errorDelivering, SetErrorDelivering] = useState(false);
    const [successDeliveringMessage, SetSuccessDeliveringMessage] = useState('');
    const [successDelivering, SetSuccessDelivering] = useState(false);
    const API_URL = process.env.REACT_APP_API_URL;

    const TURNSTILE_KEY = '0x4AAAAAABBf7H_LASwjWDgk';

    const handleCheckboxChange = () => {
        setIsChecked(!isChecked);
    };

    const InitUpdate = (data) => {
        dispatch(setRegistrationinfo(data));
    }
    useEffect(() => {
        if (!member && status === null) return;
        if (member.length === 0) {
            window.location.href = '/login';
        }
        if (member.length > 0) {
            setLocalmember(JSON.parse(member));
        }
        if (status === null) {
            return;
        }
    }, [member, status]);

    const handleSubmit = async (e) => {
        setIsLoading(true);
        e.preventDefault();
        const form = e.target;
        const formData = new FormData(form);

        const data = {
            firstname: formData.get('firstname'),
            secondname: formData.get('secondname'),
            lastname: formData.get('lastname'),
            secondlastname: formData.get('secondlastname'),
            tel: formData.get('tel'),
            email: formData.get('email'),
            email_confirmation: formData.get('email_confirmation'),
            captcharesponse: formData.get('cf-turnstile-response'),
            _token: csrfToken,
            id: localmember?.id
        };

        InitUpdate(data);

        try {
            const response = await fetch(`${API_URL}/api/arandaplus/update`, {
                method: 'POST',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'X-CSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(data),
            });

            const result = await response.json();
            if (result.status === 'success') {
                SetErrorDeliveringMessage('');
                SetErrorDelivering(false);
                SetSuccessDeliveringMessage(result.message);
                SetSuccessDelivering(true);
                dispatch(setRegistrationerror(false));
                form.reset();
                setIsLoading(false);
                setCaptchaPassed(false);
                setIsChecked(false);
            } else {
                SetErrorDeliveringMessage(result.message);
                SetErrorDelivering(true);
                SetSuccessDelivering(false);
                setIsLoading(false);
                dispatch(setRegistrationerror(true));
            }
        } catch (error) {
            SetErrorDeliveringMessage(error);
            SetErrorDelivering(true);
            SetSuccessDelivering(false);
            setIsLoading(false);
            dispatch(setRegistrationerror(true));
        }
    };

    const handleCallBackTurnstile = (data) => {
        setCaptchaPassed(true);
    }

    const handleExpirationTurnstile = () => {
        setCaptchaPassed(false);
        console.log('Turnstile - expired');
    }

    if (status === null) {
        return (
            <div id='LoyaltyProgram'>
                <Navbar />
                <section className="bg-half-170 d-table w-100" style={{ backgroundImage: `url(${hero})`, backgroundPosition: 'center' }}>
                    <div className="bg-overlay bg-gradient-overlay"></div>
                    <div className="container">
                        <div className="row mt-5 justify-content-center">
                            <div className="col-12">
                                <div className="title-heading text-center">
                                    <h5 className="heading fw-semibold mb-0 sub-heading text-white title-dark">Programa de Beneficios Aranda+</h5>
                                </div>
                            </div>
                        </div>

                        <div className="position-middle-bottom">
                            <nav aria-label="breadcrumb" className="d-block">
                                <ul className="breadcrumb breadcrumb-muted mb-0 p-0">
                                    <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                                    <li className="breadcrumb-item active">Aranda +</li>
                                    <li className="breadcrumb-item active" aria-current="page">Su cuenta</li>
                                </ul>
                            </nav>
                        </div>
                    </div>
                </section>

                <div className="position-relative">
                    <div className="shape overflow-hidden text-white">
                        <svg viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z" fill="currentColor"></path>
                        </svg>
                    </div>
                </div>
                <section className="section bg-inverted pt-3">
                    <div className="container">
                        <div className="row justify-content-center">

                            <div className="col-lg-7 col-12 mt-4 mt-md-0 p-4 pt-4 pt-md-0">
                                <div className="section-title ms-lg-5 text-center">
                                    Cargando...
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <Footer />
                <ScrollToTop />
            </div>
        )
    }

    return (
        <div id='LoyaltyProgram'>
            <Navbar />

            <section className="bg-half-170 d-table w-100" style={{ backgroundImage: `url(${hero})`, backgroundPosition: 'center' }}>
                <div className="bg-overlay bg-gradient-overlay"></div>
                <div className="container">
                    <div className="row mt-5 justify-content-center">
                        <div className="col-12">
                            <div className="title-heading text-center">
                                <h5 className="heading fw-semibold mb-0 sub-heading text-white title-dark">Programa de Beneficios Aranda+</h5>
                            </div>
                        </div>
                    </div>

                    <div className="position-middle-bottom">
                        <nav aria-label="breadcrumb" className="d-block">
                            <ul className="breadcrumb breadcrumb-muted mb-0 p-0">
                                <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                                <li className="breadcrumb-item active" aria-current="page">Aranda +</li>
                            </ul>
                        </nav>
                    </div>
                </div>
            </section>

            <div className="position-relative">
                <div className="shape overflow-hidden text-white">
                    <svg viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z" fill="currentColor"></path>
                    </svg>
                </div>
            </div>
            {/* <section className="section pb-5">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-12 col-md-6">
                            <div className="position-relative text-center">
                                <h5 className="fw-semibold">¿Cómo puedo obtener mi tarjeta Aranda+?</h5>
                                Inscríbete ahora y aprovecha estos beneficios diseñados para tu bienestar y el de tu familia.
                                <br />
                                <h4 className='text-primary'>¡Es rápido, fácil y totalmente gratuito!</h4>
                                <a href="/registro" className='btn btn-success my-4'>Registro</a>
                                <br />
                                Ya tienes una cuenta? <Link to="/login" className="text-secondary">Inicia sesión</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section> */}
            <section className="section bg-light">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-10 col-md-6 col-12">
                            <div className="p-4 bg-white rounded shadow-md mx-auto w-100 text-center">
                                <form onSubmit={handleSubmit}>
                                    <h6 className="mb-3 text-uppercase fw-semibold text-center">Gestione su perfil Aranda +</h6>
                                    <p>
                                        Puede actualizar su información personal en esta sección. Por favor, complete los campos obligatorios y acepte el aviso de privacidad para continuar.
                                    </p>
                                    {/* <img src={arandacard} alt="Aranda +" className='img-fluid w-50' /> */}
                                    <div className="row mt-4">
                                        <div className="col-md-3 mb-3 text-start">
                                            <label className="form-label fw-semibold">Nombre <span className='text-danger'>*</span></label>
                                            <input name="firstname" id="firstname" type="text" className="form-control border-primary" placeholder="Su nombre" defaultValue={localmember ? localmember.name : ''} />
                                        </div>
                                        <div className="col-md-3 mb-3 text-start">
                                            <label className="form-label fw-semibold">Segundo nombre</label>
                                            <input name="secondname" id="secondname" type="text" className="form-control border-primary" placeholder="Segundo nombre" defaultValue={localmember ? localmember.secondname : ''} />
                                        </div>
                                        <div className="col-md-3 mb-3 text-start">
                                            <label className="form-label fw-semibold">Apellido paterno <span className='text-danger'>*</span></label>
                                            <input name="lastname" id="lastname" type="text" className="form-control border-primary" placeholder="Apellido paterno" defaultValue={localmember ? localmember.lastname : ''} />
                                        </div>
                                        <div className="col-md-3 mb-3 text-start">
                                            <label className="form-label fw-semibold">Apellido materno</label>
                                            <input name="secondlastname" id="secondlastname" type="text" className="form-control border-primary" placeholder="Apellido materno" defaultValue={localmember ? localmember.secondlastname : ''} />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-6 mb-3 text-start">
                                            <label className="form-label fw-semibold">Su Email <span className='text-danger'>*</span></label>
                                            <input name="email" id="email" type="email" className="form-control border-primary" placeholder="Correo electrónico" defaultValue={localmember ? localmember.email : ''} />
                                        </div>
                                        <div className="col-md-6 mb-3 text-start">
                                            <label className="form-label fw-semibold">Su Email (confirmación) <span className='text-danger'>*</span></label>
                                            <input name="email_confirmation" id="email_confirmation" type="email" className="form-control border-primary" placeholder="Correo electrónico (nuevamente)" defaultValue={localmember ? localmember.email_confirmation : ''} />
                                        </div>
                                        <div className="col-md-6 mb-3 text-start">
                                            <label className="form-label fw-semibold">Teléfono <span className='text-danger'>*</span></label>
                                            <input name="tel" id="tel" type="tel" className="form-control border-primary" placeholder="Su móvil" defaultValue={localmember ? localmember.tel : ''} />
                                        </div>
                                    </div>
                                    <div className="form-check mb-3 text-start d-flex gap-3 justify-content-center">
                                        <input className="form-check-input border-primary" type="checkbox" value="" id="flexCheckDefault" onChange={handleCheckboxChange} />
                                        <label className="form-label form-check-label text-muted" htmlFor="flexCheckDefault">Acepto que he leido el <Link to="/aviso-privacidad" target='_blank' className="text-primary">Aviso de Privacidad</Link></label>
                                    </div>
                                    <div className="row">
                                        <div className="col-12">
                                            <Turnstile siteKey={TURNSTILE_KEY} onSuccess={handleCallBackTurnstile} onExpire={handleExpirationTurnstile} />
                                        </div>
                                    </div>
                                    {captchaPassed && !isLoading && (
                                        <button className="btn btn-primary w-50" type="submit" disabled={!isChecked}>Guardar cambios</button>
                                    )}
                                    {isLoading && (
                                        <div className="spinner-border text-success mx-auto my-2 text-center" role="status">
                                            <span className="visually-hidden text-center">Enviando, espere...</span>
                                        </div>
                                    )}
                                    {errorDelivering && (
                                        <>
                                            <br />
                                            <div className="alert alert-warning text-dark alert-dismissible fade show mt-4" role="alert">
                                                <strong>No se pudo realizar la actualización, revise lo siguiente: </strong> {errorDeliveringMessage}
                                            </div>
                                        </>
                                    )}
                                    {successDelivering && (
                                        <>
                                            <br />
                                            <div className="alert alert-success alert-dismissible fade show mt-4" role="alert">
                                                <strong>{successDeliveringMessage}</strong>
                                            </div>
                                        </>
                                    )}
                                    <hr className='w-50 mx-auto mt-5 border-muted' />
                                    <div className="col-12 text-center text-muted mt-5 small">
                                        <LuInfo /> <strong>Nota:</strong> Todos los campos marcados con <span className='text-danger'>*</span> son obligatorios.
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <Footer />

            <ScrollToTop />
        </div>
    )
}
